export default __webpack_public_path__ + "static/media/bear-share.d64a2aa1.png";